import RxGateReceiptTable from './RxGateReceiptTable';

export default RxGateReceiptTable;
